import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
// Production-safe logging (sanitizes logs and silences verbose output in PROD)
import './config/safe-logging'
// Import environment configuration
import './config/environment'
// Import session debugging utilities in development
import './utils/sessionDebug'

ReactDOM.createRoot(document.getElementById("root")!).render(
  // Temporariamente desabilitado StrictMode para resolver problemas de autenticação em desenvolvimento
  // TODO: Re-habilitar após resolver completamente os problemas de múltiplas instâncias
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)
